document.addEventListener("DOMContentLoaded", () => {
  const footer = document.querySelector("footer");
  if (!footer) return;

  const anchors = footer.querySelectorAll('a[href]');
  anchors.forEach((a) => {
    const href = a.getAttribute("href");
    if (!href) return;

    // skip anchors + mail + tel
    if (href.startsWith("#")) return;
    if (href.startsWith("mailto:")) return;
    if (href.startsWith("tel:")) return;

    // only handle absolute external links
    // (starts with http/https)
    if (!href.startsWith("http://") && !href.startsWith("https://")) return;

    try {
      const url = new URL(href);
      if (url.hostname && url.hostname !== window.location.hostname) {
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener noreferrer");
      }
    } catch (e) {
      // ignore invalid URLs
    }
  });
});
